import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { PARENT_ROUTES as PARENT_ROUTE_CONSTANTS } from '../../route-constants';

const ParentHome = lazy(() => import('@~/pages/parent/home/parent-home'));
const BookSlot = lazy(() => import('@~/pages/parent/onboarding/book-slot/book-slot'));

const OnboardingRoutesWrapper = lazy(
  () => import('@~/pages/parent/onboarding/onboarding-routes-wrapper'),
);
const ParentRoutesWrapper = lazy(() => import('@~/pages/parent/parent-routes-wrapper'));
const ParentRootPage = lazy(() => import('@~/pages/parent/parent-root-page'));

export const PARENT_ROUTES: RouteObject = {
  path: PARENT_ROUTE_CONSTANTS.ROOT.PATH,
  element: <ParentRoutesWrapper />,
  handle: {
    pageName: PARENT_ROUTE_CONSTANTS.ROOT.NAME,
  },
  children: [
    {
      path: PARENT_ROUTE_CONSTANTS.ROOT.PATH,
      element: <ParentRootPage />,
      handle: {
        pageName: PARENT_ROUTE_CONSTANTS.ROOT.NAME,
      },
    },
    {
      path: PARENT_ROUTE_CONSTANTS.HOME.PATH,
      element: <ParentHome />,
      handle: {
        pageName: PARENT_ROUTE_CONSTANTS.HOME.NAME,
      },
    },
    {
      path: PARENT_ROUTE_CONSTANTS.ONBOARDING.RELATIVE_PATH,
      element: <OnboardingRoutesWrapper />,
      handle: {
        pageName: PARENT_ROUTE_CONSTANTS.ONBOARDING.NAME,
      },
      children: [
        {
          path: PARENT_ROUTE_CONSTANTS.RESCHEDULE_DEMO.RELATIVE_PATH,
          element: <BookSlot />,
          handle: {
            pageName: PARENT_ROUTE_CONSTANTS.RESCHEDULE_DEMO.NAME,
          },
        },
      ],
    },
  ],
};
